
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/localized/[sourceLanguageLocale]/[learnSlug]/[courseSlug]/campaigns/dreamworks-puss-in-boots-the-last-wish",
      function () {
        return require("private-next-pages/localized/[sourceLanguageLocale]/[learnSlug]/[courseSlug]/campaigns/dreamworks-puss-in-boots-the-last-wish/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/localized/[sourceLanguageLocale]/[learnSlug]/[courseSlug]/campaigns/dreamworks-puss-in-boots-the-last-wish"])
      });
    }
  